import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { ChangeContributionDataForm } from './ChangeContributionDataForm'

export const ChangeContributionDataNestedCommand = ({
  employerAgreementId,
  ...props
}: ActionButtonProps & { employerAgreementId: string }) => {
  const translate = useTranslate()
  const tenantId = useHook('routing.tenant.useTenantParam')()

  const actions = useHook(
    'mutators.life.useChangeContributionDataCommandActions',
  )({
    tenantId,
    employerAgreementId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="life.ChangeContributionDataCommandData"
      title={translate('changeContributionData.title')}
      commandDataForm={ChangeContributionDataForm}
      submit={submit}
      {...props}
    />
  )
}
